import axios from "axios";
import { jwtDecode } from "jwt-decode";

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const AUTH_INVALIDATED_KEY = "authInvalidated";

export const getAuthMetadata = (currentUser) => currentUser?.metadata || {};

export const getAuthUser = (currentUser) => getAuthMetadata(currentUser).user || {};

export const getUserId = (currentUser) => {
  const user = getAuthUser(currentUser);

  return user._id || user.user_id || user.id || currentUser?.user_id || null;
};

export const getAccessToken = (currentUser) =>
  localStorage.getItem(AUTH_INVALIDATED_KEY) === "true"
    ? null
    : localStorage.getItem(ACCESS_TOKEN_KEY) ||
      getAuthMetadata(currentUser).tokens?.accessToken ||
      null;

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const persistAuthTokens = (tokens = {}) => {
  if (tokens.accessToken || tokens.refreshToken) {
    localStorage.removeItem(AUTH_INVALIDATED_KEY);
  }
  if (tokens.accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
  if (tokens.refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
};

export const clearAuthStorage = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.setItem(AUTH_INVALIDATED_KEY, "true");
  window.dispatchEvent(new Event("lingualica:auth-invalidated"));
};

export const decodeToken = (token) => {
  try {
    return token ? jwtDecode(token) : null;
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded?.exp) return true;

  return decoded.exp <= Date.now() / 1000;
};

export const hasUsableSession = (currentUser) =>
  Boolean(getUserId(currentUser) && getAccessToken(currentUser));

export const refreshCurrentUser = async (currentUser) => {
  const userID = getUserId(currentUser);
  const refreshToken = getRefreshToken();

  if (!userID || !refreshToken) return null;

  const res = await axios.post(
    `${REACT_APP_BASE_URL}user/refresh-token`,
    {},
    {
      headers: {
        user: userID,
        token: refreshToken,
      },
    }
  );

  const tokens = res.data?.metadata?.tokens;
  if (!tokens?.accessToken || !tokens?.refreshToken) return null;

  persistAuthTokens(tokens);

  return {
    ...currentUser,
    metadata: {
      ...currentUser.metadata,
      tokens,
    },
  };
};
